<template>
  <div>
    <div class="row">
      <div class="col-md-6 col-sm-12">
        <div class="card">
          <div class="card-content">
            <div class="card-body pb-1">
              <h5 class="card-title">{{$t('Proposals')}}</h5>

              <ul class="list-group list-group-flush">
                <li
                  class="list-group-item border-0 d-flex align-items-center justify-content-between px-0"
                  v-for="(count, t) in lifetimeStats.proposals"
                  :key="t"
                >
                  <div class="list-left d-flex">
                    <div class="list-content">
                      <span class="list-title capitalize">{{ t }}</span>
                    </div>
                  </div>
                  <span class="badge badge-secondary">{{ count }}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-6 col-sm-12">
        <div class="card">
          <div class="card-content">
            <div class="card-body pb-1">
              <h5 class="card-title">{{$t('Properties')}}</h5>

              <ul class="list-group list-group-flush">
                <li
                  class="list-group-item border-0 d-flex align-items-center justify-content-between px-0"
                  v-for="(count, t) in lifetimeStats.properties"
                  :key="t"
                >
                  <div class="list-left d-flex">
                    <div class="list-content">
                      <span class="list-title capitalize">{{ t }}</span>
                    </div>
                  </div>
                  <span class="badge badge-secondary">{{ count }}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-content">
            <div class="card-body pb-1">
              <h5 class="card-title">{{$t('Issues')}}</h5>

              <ul class="list-group list-group-flush">
                <li
                  class="list-group-item border-0 d-flex align-items-center justify-content-between px-0"
                  v-for="(count, t) in lifetimeStats.issues"
                  :key="t"
                >
                  <div class="list-left d-flex">
                    <div class="list-content">
                      <span class="list-title capitalize">{{ t }}</span>
                    </div>
                  </div>
                  <span class="badge badge-secondary">{{ count }}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-content">
            <div class="card-body pb-1">
              <h5 class="card-title">{{$t('Invites')}}</h5>

              <ul class="list-group list-group-flush">
                <li
                  class="list-group-item border-0 d-flex align-items-center justify-content-between px-0"
                  v-for="(count, t) in lifetimeStats.invites"
                  :key="t"
                >
                  <div class="list-left d-flex">
                    <div class="list-content">
                      <span class="list-title capitalize">{{ t }}</span>
                    </div>
                  </div>
                  <div>
                    <span class="badge badge-info">{{ count.sent }}</span>
                    <span class="badge badge-success">{{
                      count.accepted
                    }}</span>
                    <span class="badge badge-danger">{{ count.deleted }}</span>
                  </div>
                </li>
              </ul>

              <div class="mt-3 text-center">
                <span class="badge badge-info">{{$t('Sent')}}</span>
                <span class="badge badge-success">{{$t('Accepted')}}</span>
                <span class="badge badge-danger">{{$t('Deleted')}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["lifetimeStats"],
};
</script>